import { render, staticRenderFns } from "./SystemHistory.vue?vue&type=template&id=c2e921f4&scoped=true&"
import script from "./SystemHistory.vue?vue&type=script&lang=ts&"
export * from "./SystemHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SystemHistory.vue?vue&type=style&index=0&id=c2e921f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e921f4",
  null
  
)

export default component.exports